module.exports = __webpack_public_path__ + "img/Locations.32106892.svg";